import { fetcher } from '@commenda/utils';
import { CreateTransferPricingOnboardingParams } from './types';

const createTransferPricingOnboarding = async (
  body: CreateTransferPricingOnboardingParams
) => {
  const res = await fetcher('transfer-pricing/onboarding', {
    method: 'POST',
    body,
  });

  return res;
};

export { createTransferPricingOnboarding };
